import { render, staticRenderFns } from "./PersonAgency.vue?vue&type=template&id=1af19054&scoped=true"
import script from "./PersonAgency.vue?vue&type=script&lang=js"
export * from "./PersonAgency.vue?vue&type=script&lang=js"
import style0 from "./PersonAgency.vue?vue&type=style&index=0&id=1af19054&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af19054",
  null
  
)

export default component.exports